import {TimestampStatus} from "./timestamps";

export interface Communication {
    id: string;
    timestamps: {
        request: string;
        response?: string;
    };
    ip: string;
    method: string;
    url: string;
    originalUrl: string;
    responseStatus?: {
        code: number;
        message: string;
    };
}

export interface AuditTrail {
    interactionId: number;
    createdAt: Date;
    digests: {
        pcap: string;
        keys?: string;
        authReqs?: string;
    };
    hostOS: string;
    communications: Communication[];
    userArrivedAt: Date;
    userTookOffAt: Date;
    signedAt?: Date;
}

export enum InteractionStatus {
    Subscribed = "SUBSCRIBED",
    // InstantiatingPod = "INSTANTIATING_POD", // Useless
    //PodReady = "POD_READY", // Determinable with FK
    PodFailed = "POD_FAILED", // Final
    Concluding = "CONCLUDING",
    OUrlFailed = "OURL_FAILED", // Final
    ConcludingFailed = "CONCLUDING_FAILED",
    Concluded = "CONCLUDED", // Final
    Rejected = "REJECTED", // Final
    // Expired = "EXPIRED" // Determinable with column expiresAt
}

export enum AppStatus {
    ONGOING = "ONGOING",
    CONCLUDED = "CONCLUDED",
    FAILED = "FAILED",
    REJECTED = "REJECTED",
}

export enum TimestampAppStatus {
    ONGOING = "ONGOING",
    CONCLUDED = "CONCLUDED",
    FAILED = "FAILED",
}

export const InteractionStatusAppStatusMap = {
    [InteractionStatus.Subscribed]: AppStatus.ONGOING,
    [InteractionStatus.PodFailed]: AppStatus.FAILED,
    [InteractionStatus.Concluding]: AppStatus.ONGOING,
    [InteractionStatus.OUrlFailed]: AppStatus.FAILED,
    [InteractionStatus.Concluded]: AppStatus.CONCLUDED,
    [InteractionStatus.ConcludingFailed]: AppStatus.FAILED,
    [InteractionStatus.Rejected]: AppStatus.REJECTED,
}

export const TimestampStatusAppStatusMap = {
    [TimestampStatus.CREATED]: AppStatus.ONGOING,
    [TimestampStatus.CONCLUDED]: AppStatus.CONCLUDED,
    [TimestampStatus.FAILED]: AppStatus.FAILED,
}

export const AppStatusToInteractionStatusMap = {
    [AppStatus.ONGOING]: [InteractionStatus.Subscribed, InteractionStatus.Concluding].join(","),
    [AppStatus.FAILED]: [InteractionStatus.PodFailed, InteractionStatus.OUrlFailed, InteractionStatus.ConcludingFailed].join(","),
    [AppStatus.CONCLUDED]: [InteractionStatus.Concluded].join(","),
    [AppStatus.REJECTED]: [InteractionStatus.Rejected].join(","),
}

export const AppStatusToTimestampStatusMap = {
    [TimestampAppStatus.ONGOING]: [TimestampStatus.CREATED].join(","),
    [TimestampAppStatus.CONCLUDED]: [TimestampStatus.CONCLUDED].join(","),
    [TimestampAppStatus.FAILED]: [TimestampStatus.FAILED].join(","),
}

export const AppStatusToColorMap = {
    [AppStatus.ONGOING]: "warning",
    [AppStatus.FAILED]: "danger",
    [AppStatus.CONCLUDED]: "success",
    [AppStatus.REJECTED]: "secondary",
}

export const AppStatusToIconMap = {
    [AppStatus.ONGOING]: "clock",
    [AppStatus.FAILED]: "times-circle",
    [AppStatus.CONCLUDED]: "check-circle",
    [AppStatus.REJECTED]: "ban",
}

export interface Signature {
    id: number;
    expirationPeriod: number;
    expiresAt: Date;
    userLandedAt: Date | null;
    userTookoffAt: Date | null;
    currentStatus: InteractionStatus;
    archetypeId: number | null;
    createdAt: Date;
    updatedAt: Date;
    tags: { [key: string]: object | string | null | undefined };
    downloadableUntil?: Date;
    deletedEvidence: boolean;
    deletedAt?: Date;
}

export interface BasicSignature extends Signature{
    id: number;
    oURL: string;
    oMethod: string | null;
    actAsProxy: boolean;
    assignationExpirationPeriod: number;
    variation: "no_html" | "full";
}

export interface SignatureFull extends Signature {
    attachedFiles?: {
        xmlUrl: string;
        xmlSize: number;
    };
    auditTrailXML?: string;
    auditTrail?: AuditTrail;
}

export interface BasicSignatureFull extends BasicSignature, SignatureFull {
}
